import React from 'react';
import PropTypes from 'prop-types';
import Money from '../../../../../common/money';

const TotalSalesBreakdownTableRowExpanded = ({ row, showLoanRepayment }) => (
  <div className="c-total-sales-breakdown-table-expanded">
    {row._original.items.map(item => ( // eslint-disable-line no-underscore-dangle
      <div className="c-total-sales-breakdown-table-expanded__row">
        <div
          className="c-total-sales-breakdown-table-expanded__cell c-total-sales-breakdown-table-expanded__cell--expanded" // eslint-disable-line max-len
        >
          {item.title}
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.grossTotal}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.grossRefunds}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.grossPromo + item.grossDiscounts}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.netTotal}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.fees}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell" display-if={showLoanRepayment}>
          <Money>{item.loanRepaymentCharge}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.tax}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.tips}</Money>
        </div>
        <div className="c-total-sales-breakdown-table-expanded__cell">
          <Money>{item.totalCollected}</Money>
        </div>
      </div>
    ))}
  </div>
);
TotalSalesBreakdownTableRowExpanded.propTypes = {
  row: PropTypes.shape({
    _original: PropTypes.object,
  }).isRequired,
  showLoanRepayment: PropTypes.bool.isRequired,
};

export default TotalSalesBreakdownTableRowExpanded;
